import Vue from 'vue';
import IdleVue from "idle-vue";
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';

// router setup
import router from './routes/router';
import store from './store/index';
// plugin setup
Vue.use(DashboardPlugin);

const eventsHub = new Vue()

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: ((1 * (30 * (60 * 1000))) - (2 * (60 * 1000))), // 3 seconds,
    startAtIdle: false
});

new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store
});